// All overlays share ownership: a nested viewer must not unlock its parent.
let owners = 0;
let restore: (() => void) | undefined;

export function lockDocumentScroll(): () => void {
  if (owners++ === 0) {
    const body = document.body;
    const y = window.scrollY;
    const restoration = window.history.scrollRestoration;
    const original = {
      position: body.style.position, top: body.style.top,
      left: body.style.left, right: body.style.right,
      width: body.style.width, overflow: body.style.overflow,
      paddingRight: body.style.paddingRight,
    };
    const gutter = window.innerWidth - document.documentElement.clientWidth;
    window.history.scrollRestoration = "manual";
    Object.assign(body.style, {
      position: "fixed", top: `${-y}px`, left: "0", right: "0",
      width: "100%", overflow: "hidden",
    });
    if (gutter > 0) body.style.paddingRight = `${gutter}px`;
    restore = () => {
      Object.assign(body.style, original);
      window.scrollTo({ top: y, behavior: "instant" as ScrollBehavior });
      window.history.scrollRestoration = restoration;
    };
  }
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--owners === 0) {
      restore?.();
      restore = undefined;
    }
  };
}
